import React from 'react';
import useStyle from './ObjectiveUpdate.style';
import { LabelInput } from '../../../atoms/Inputs/LabelInput';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import { updateClassObjectiveErrorHandling } from '../../../../helpers/forms/formsErrorHandling/updateClassObjectiveErrorHandling';

type setActiveObjectiveType = {
  values: {
    name: string | null;
    ca: string | null;
  };
  errors: {
    name: boolean;
    ca: boolean;
  };
  isValid: boolean;
};

interface ObjectiveUpdateViewProps {
  activeObjective: setActiveObjectiveType;
  setActiveObjective: (activeObjective: setActiveObjectiveType) => void;
  setShowObjective: (show: boolean) => void;
  handleOnClick: () => void;
  putAction: boolean;
}

const ObjectiveUpdateView = ({
  activeObjective,
  setActiveObjective,
  setShowObjective,
  handleOnClick,
  putAction
}: ObjectiveUpdateViewProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      <h2>{putAction ? "Modifier l'" : 'Créer un '}objectif</h2>
      <p>
        Définissez un projet classe qui sera financé par votre commission ; puis
        fixez votre ambition de C.A. associé.
      </p>
      <form className={classes.form}>
        <div className={classes.inputs}>
          <LabelInput
            label="Nom de l'objectif"
            name="name"
            placeHolder="ex : séminaire de révision à Albi"
            onChange={event =>
              setActiveObjective(
                updateClassObjectiveErrorHandling(
                  activeObjective,
                  'name',
                  event.target.value
                )
              )
            }
            value={activeObjective?.values?.name || ''}
            required={true}
            error={
              activeObjective.errors.name &&
              activeObjective?.errors?.name?.toString()
            }
          />
          <LabelInput
            label="Objectif CA (en €)"
            name="objectiveca"
            placeHolder="ex : 4000"
            onChange={event =>
              setActiveObjective(
                updateClassObjectiveErrorHandling(
                  activeObjective,
                  'ca',
                  event.target.value
                )
              )
            }
            value={activeObjective?.values?.ca?.toString() || ''}
            required={true}
            error={
              activeObjective.errors.ca &&
              activeObjective?.errors?.ca?.toString()
            }
          />
        </div>
        <div className={classes.actions}>
          {putAction && (
            <ButtonWithText
              variant={'primaryBlue'}
              content={'Retour'}
              onClick={() => setShowObjective(true)}
            />
          )}
          <ButtonWithText
            variant={'primaryBlue'}
            content={putAction ? 'Enregistrer' : 'Créer'}
            onClick={handleOnClick}
            disabled={
              !activeObjective.isValid ||
              !activeObjective.values.name ||
              !activeObjective.values.ca
            }
          />
        </div>
      </form>
    </div>
  );
};

export default ObjectiveUpdateView;
